import { useParams } from "react-router-dom";
import { useEffect, useState } from "react";
import { AlertCircle, QrCode } from "lucide-react";
import { PublicBookingAPI } from "../../services/publicBooking.api";
import TicketCard from "../../components/booking/TicketCard";
import ErrorState from "../../components/ErrorState";
import { socket } from "../../utils/socket";
import "./BookingTicketPage.scss";

export default function BookingTicketPage() {
  const { id } = useParams();
  const [booking, setBooking] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  async function loadTicket() {
    try {
      const data = await PublicBookingAPI.getTicket(id);
      console.log('data booking public', data);
      setBooking(data);
      setError("");
    } catch (err) {
      setError(
        err.response?.data?.message ||
          "Tiket belum tersedia."
      );
    } finally {
      setLoading(false);
    }
  }

  /* ================= INITIAL LOAD ================= */
  useEffect(() => {
    loadTicket();
  }, [id]);

  /* ================= SOCKET REALTIME ================= */
  useEffect(() => {
    socket.connect();
    socket.emit("join-booking-room", id);

    socket.on("payment-updated", ({ paymentStatus }) => {
      setBooking((prev) =>
        prev ? { ...prev, paymentStatus } : prev
      );
    });

    socket.on("booking:scanned", ({ bookingId, ticketCode }) => {
      if (bookingId === id && ticketCode) {
        setBooking((prev) =>
          prev
            ? {
                ...prev,
                tickets: prev.tickets?.map((t) =>
                  t.code === ticketCode
                    ? { ...t, status: "used", scannedAt: new Date().toISOString() }
                    : t
                ),
              }
            : prev
        );
      }
    });

    return () => {
      socket.emit("leave-booking-room", id);
      socket.off("payment-updated");
      socket.off("booking:scanned");
    };
  }, [id]);

  /* ================= AUTO REFRESH FALLBACK ================= */
  useEffect(() => {
    if (booking?.paymentStatus === "PENDING") {
      const interval = setInterval(loadTicket, 5000);
      return () => clearInterval(interval);
    }
  }, [booking?.paymentStatus]);

  if (loading)
    return (
      <div className="ticket-wrapper">
        <div className="ticket-loading">
          Loading ticket…
        </div>
      </div>
    );

  if (error)
    return (
      <ErrorState
        icon={AlertCircle}
        title="Terjadi Kesalahan"
        message={error}
        action={{ label: "Kembali", onClick: () => window.history.back() }}
        secondaryAction={{ label: "← Kembali ke Beranda", href: "/" }}
      />
    );

  if (booking.paymentStatus !== "PAID")
    return (
      <div className="ticket-wrapper">
        <div className="ticket-warning">
          {booking.paymentStatus === "PENDING"
            ? "Menunggu pembayaran dikonfirmasi..."
            : "Tiket belum aktif."}
        </div>
      </div>
    );

  if (!booking?.tickets?.length)
    return (
      <ErrorState
        icon={QrCode}
        title="QR Belum Tersedia"
        message="QR tiket kamu belum siap. Silakan coba lagi dalam beberapa saat."
        action={{ label: "Refresh", onClick: () => window.location.reload() }}
        secondaryAction={{ label: "← Kembali ke Beranda", href: "/" }}
      />
    );

  return (
    <div className="ticket-wrapper">
      <TicketCard booking={booking} tickets={booking.tickets} />

      {booking.tickets?.some((t) => t.scannedAt) && (
        <div className="ticket-used">
          ✅ Tiket sudah digunakan pada{" "}
          {new Date(
            booking.tickets.find((t) => t.scannedAt)?.scannedAt
          ).toLocaleString("id-ID")}
        </div>
      )}

      <div className="ticket-note">
        Tiket resmi dan hanya dapat digunakan 1 kali per kode.
      </div>
    </div>
  );
}
